import { Directive, ElementRef, Renderer2 } from '@angular/core';
import * as VMasker from 'vanilla-masker';

@Directive({
    selector: '[CPFMask]',
})
export class CPFMaskDirective {
    public nativeElement: HTMLInputElement;

    constructor(
        public element: ElementRef,
        public render: Renderer2,
    ) {
        this.nativeElement = this.element.nativeElement;
        this.render.listen(this.nativeElement, 'keyup', () => {
            const replacedValue = (this.nativeElement.value).replace(/[_\W]+/g, '');
            const valueLengeth = replacedValue.length;
            let mask;
            if (valueLengeth <= 11) { mask = '999.999.999-99?9'; } else { mask = '99.999.999/9999-99'; }
            VMasker(this.nativeElement)
                .maskPattern(mask);
        });
    }
}
